import { render, staticRenderFns } from "./TagSelection.vue?vue&type=template&id=4bc427d0&scoped=true"
import script from "./TagSelection.vue?vue&type=script&lang=js"
export * from "./TagSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc427d0",
  null
  
)

export default component.exports